import React from 'react';
import {
  ChevronDoubleUpIcon,
  ChevronUpIcon,
  MinusIcon,
  ChevronDownIcon
} from '@heroicons/react/24/outline';

const PRIORITY_STYLES = {
  P0: 'bg-red-50 text-red-700 ring-red-100',
  P1: 'bg-orange-50 text-orange-700 ring-orange-100',
  P2: 'bg-blue-50 text-blue-700 ring-blue-100',
  P3: 'bg-emerald-50 text-emerald-700 ring-emerald-100'
};

const PRIORITY_ICONS = {
  P0: ChevronDoubleUpIcon,
  P1: ChevronUpIcon,
  P2: MinusIcon,
  P3: ChevronDownIcon
};

const PRIORITY_ICON_COLORS = {
  P0: 'text-red-600',
  P1: 'text-orange-600',
  P2: 'text-blue-500',
  P3: 'text-emerald-600'
};

const PriorityPill = ({ priority, className = '', t }) => {
  if (!priority) return null;

  if (t) {
    const Icon = PRIORITY_ICONS[priority];
    const label = t(`assistant.priority.levels.${priority}.label`);
    const title = t(`assistant.priority.levels.${priority}.title`);
    const color = PRIORITY_ICON_COLORS[priority] || 'text-gray-600';
    const bg = PRIORITY_STYLES[priority]?.split(' ')[0] || 'bg-gray-50';

    if (!Icon) return null;

    return (
      <div
        className={`flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[11px] font-semibold ${color} ${bg} ${className}`}
        title={title}
      >
        <Icon className="h-3.5 w-3.5" />
        <span>{label}</span>
      </div>
    );
  }

  const styles = PRIORITY_STYLES[priority] || 'bg-gray-50 text-gray-600 ring-gray-100';

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${styles} ${className}`}
    >
      {priority}
    </span>
  );
};

PriorityPill.displayName = 'PriorityPill';

export default PriorityPill;
